import { render } from "./OtherEdit.vue?vue&type=template&id=08e063ea"
import script from "./OtherEdit.vue?vue&type=script&lang=js"
export * from "./OtherEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__